import { fromJS } from 'immutable'
import moment from '../../../lib/moment'

import { GET_REPORT, DATE, GP, VALUE, FILTER, SORT, MODULE } from './constants'
import { toProjects } from './model'

/**
 * @typedef {import('./model').GPType} GPType
 * @typedef {import('./model').ValueType} ValueType
 * @typedef {import('./model').PPSReport} PPSReport
 */

/** @type {import('immutable').Map} */
const initialState = fromJS({
  fetching: false,
  display_actual: false,
  date: {
    from: moment().subtract(6, 'months'),
    to: moment(),
  },
  filter: {
    lob: '',
    other: '',
  },
  sort: { field: 'code', order: 'asc' },
  gp_type: /** @type {GPType} */ ('service'),
  value_type: /** @type {ValueType} */ ('standard'),
  projects: /** @type {PPSReport[]} */ ([]),
})

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_REPORT.REQUEST:
      return state.set('fetching', true)
    case GET_REPORT.SUCCESS:
      return state
        .set('fetching', false)
        .set('projects', fromJS(toProjects(action.payload)))
        .set('display_actual', Boolean(action.payload.can_display_actual_cost))
    case GET_REPORT.FAILURE:
      return state
    case DATE.SET_FIELD:
      return state.setIn(['date', action.payload[0]], action.payload[1])
    case FILTER.SET_FIELD:
      return state.setIn(['filter', action.payload[0]], action.payload[1])
    case SORT.SET_FIELD:
      return state.setIn(['sort', action.payload[0]], action.payload[1])
    case GP.SET:
      return state.set('gp_type', action.payload)
    case VALUE.SET:
      return state.set('value_type', action.payload)
    case MODULE.RESET:
      return initialState
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/pages/report/project-profit-sheet/reducer.js